<template>
	<div>
		<transition name="toggle-message" mode="out-in">
			<div class="message-wrapper" id="Message" v-if="errorMessage">
				<div class="error">
					<div class="status-filed"></div>
					<div class="message-body" v-html="errorMessage"></div>
					<button type="button" @click="closeErrorMessage()">
						&times;
					</button>
				</div>
			</div>
		</transition>
		<transition>
			<div class="message-wrapper" id="Message" v-if="successMessage">
				<div class="success">
					<div class="status-filed"></div>
					<div class="message-body">{{ successMessage }}</div>
					<button type="button" @click="closeSuccessMessage()">
						&times;
					</button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	methods: {
		closeErrorMessage() {
			this.$store.commit('setGlobalErrorMessage', '');
		},
		closeSuccessMessage() {
			this.$store.commit('setGlobalSuccessMessage', '');
		},
	},
	computed: {
		errorMessage() {
			return this.$store.getters.getGlobalErrorMessage
				? this.$store.getters.getGlobalErrorMessage
				: false;
		},
		successMessage() {
			return this.$store.getters.getGlobalSuccessMessage
				? this.$store.getters.getGlobalSuccessMessage
				: false;
		},
	},
	updated() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	},
	mounted() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	},
};
</script>
